import {
  DEVICE_GROUPS_FETCH_FAILED,
  DEVICE_GROUPS_FETCHED,
  DEVICE_GROUPS_RESET,
  FETCH_DEVICE_GROUPS,
  FetchDeviceGroupsActionTypes,
  TOGGLE_SELECT_ALL_DEVICE_GROUPS,
  TOGGLE_SELECT_DEVICE_GROUP
} from './paginated-device-group-action-types';
import { DeviceGroupSelectable } from '../../../utils/device-group-selectable';
import { DEVICE_KEY_ASSIGNED_TO_USER } from '../../device-key/deviceKeyActionTypes';


type DeviceGroupsState = {
  currentPageItems: DeviceGroupSelectable[];
  currentPageItemsAreOutdated: boolean;
  selectedItems: DeviceGroupSelectable[];
  isLoadingDeviceGroups: boolean;
};

const initialState: DeviceGroupsState = {
  currentPageItems: [],
  currentPageItemsAreOutdated: false,
  selectedItems: [],
  isLoadingDeviceGroups: false,
};

export const paginatedDeviceGroupsReducer = (
  state: DeviceGroupsState = initialState,
  action: FetchDeviceGroupsActionTypes,
): DeviceGroupsState => {
  switch (action.type) {
    case DEVICE_KEY_ASSIGNED_TO_USER:
      return {
        ...state,
        currentPageItemsAreOutdated: true,
      };

    case FETCH_DEVICE_GROUPS:
      return {
        ...state,
        isLoadingDeviceGroups: true,
      };

    case DEVICE_GROUPS_FETCHED:
      return {
        ...state,
        currentPageItems:
          action.deviceGroups.deviceGroups.map(dg => ({ ...dg, isSelected: false })),
        selectedItems: [],
        isLoadingDeviceGroups: false,
        currentPageItemsAreOutdated: false,
      };

    case DEVICE_GROUPS_FETCH_FAILED:
      return { ...state, isLoadingDeviceGroups: false };


    case TOGGLE_SELECT_DEVICE_GROUP:
      const updatedList = toggleSelectionOfOneGroup(action.deviceGroupId, [...state.currentPageItems]);
      return {
        ...state,
        currentPageItems: updatedList,
        selectedItems: updatedList.filter(deviceGroup => deviceGroup.isSelected)
      };

    case TOGGLE_SELECT_ALL_DEVICE_GROUPS:
      const updated = toggleSelectionOfAllGroups(action.newValue, [...state.currentPageItems]);
      return {
        ...state,
        currentPageItems: updated,
        selectedItems: updated.filter(deviceGroup => deviceGroup.isSelected)
      };

    case DEVICE_GROUPS_RESET:
      return initialState;

    default:
      return state;
  }
};

const toggleSelectionOfOneGroup = (
  deviceGroupId: string,
  list: DeviceGroupSelectable[]
): DeviceGroupSelectable[] => {
  const updatedList = [...list].map(
    deviceGroup => {
      if (deviceGroup.id === deviceGroupId) {
        deviceGroup.isSelected = !deviceGroup.isSelected;
      }

      return deviceGroup;
    }
  );

  return updatedList;
};

const toggleSelectionOfAllGroups = (
  newValue: boolean,
  list: DeviceGroupSelectable[]
): DeviceGroupSelectable[] => {
  const updatedList = [...list].map(deviceGroup => (
    { ...deviceGroup, isSelected: newValue }
  ));

  return updatedList;
};
